/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Input, Modal, Row, Col } from "antd";
import { jsPDF as JSpdf } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import moment from "moment";
import IntlMessages from "util/IntlMessages";
import { getEvents } from "../../redux/actions/Event";
import PageLimitSwitch from "../../components/PageLimitSwitch";

import generateQuery, { handleSearch as search } from "../../util/table";
import DownloadBtns from "../../components/common/downloadbtns";
import logo from "../../assets/images/kitegateway_icon_dark.png";
import EventDetailsForModal from "./EventDetailsForModal";

const columns = [
  {
    title: "Created",
    dataIndex: "created_at",
    render: (date) => <span>{moment(date).format("DD/MM/YY h:mm:ss a")}</span>,
    sorter: true,
    search: false,
  },
  {
    title: "Kitegateway Reference",
    dataIndex: "kitegateway_reference",
    sorter: true,
  },
  {
    title: "EventLog Type",
    dataIndex: "event_type",
    sorter: true,
  },
  {
    title: "EventLog Name",
    dataIndex: "event_name",
    sorter: true,
  },
  {
    title: "Server Name",
    dataIndex: "server_name",
    sorter: true,
  },
  {
    title: "Remark",
    dataIndex: "remark",
    sorter: true,
  },
];

const EventLog = () => {
  const dispatch = useDispatch();
  const { data, pageSize, currentPage, totalRecords, loading } = useSelector(
    ({ event_log }) => event_log.event_logs
  );
  const [searchParams, setSearchParams] = useState("");

  useEffect(() => {
    const pagination = `page=${currentPage}&limit=${pageSize}`;
    dispatch(getEvents(pagination));
  }, [dispatch, pageSize, currentPage]);

  const [visibleEventModal, setVisibilityEventModal] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(false);

  const dataSource =
    data.length &&
    data.length &&
    data.map(
      ({
        _id,
        kitegateway_reference,
        event_type,
        event_name,
        server_name,
        input_details,
        output_details,
        remark,
        created_at,
        updated_at,
      }) => ({
        key: _id,
        kitegateway_reference,
        event_type,
        event_name,
        server_name,
        input_details,
        output_details,
        remark,
        created_at,
        updated_at,
      })
    );

  const navigateToView = (record) => ({
    onClick: () => {
      setSelectedEventId(record.key);
      setVisibilityEventModal(true);
    },
  });

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(
      getEvents(generateQuery(pagination, filters, sorter, searchParams))
    );
  };

  const handleSearch = (searchValue) => {
    const query = search(searchValue, dispatch, getEvents, columns);
    setSearchParams(query);
  };

  const props = {
    pagination: false,
    onRow: navigateToView,
    onChange: handleOnChange,
    loading,
    columns,
    dataSource,
  };
  function handlePdf(cols, datar, file) {
    const time = moment(Date.now()).format("DD-MM-YYYY");
    const incoming = datar.dataSource;
    const bodyData = [];
    const doc = new JSpdf({ orientation: "landscape" });
    doc.addImage(logo, "PNG", 0, 0, 43.85, 17.06);
    doc.text(`${file} - ${time}`, 50, 10);
    for (let i = 0; i < incoming.length; i += 1) {
      bodyData.push([
        incoming[i].kitegateway_reference,
        incoming[i].event_type,
        incoming[i].event_name,
        incoming[i].server_name,
        "",
        "",
        incoming[i].remark,
      ]);
    }
    doc.autoTable({
      margin: { top: 19, left: 1, right: 1 },
      head: [cols.columns],
      body: bodyData,
    });
    doc.save(`${file} - ${time}.pdf`);
  }
  function handleXcl(cols, datar, file) {
    const time = moment(Date.now()).format("DD-MM-YYYY");
    const header = [];
    const col = cols.columns;
    for (let i = 0; i < col.length; i += 1) {
      header.push(col[i].title);
    }
    const incoming = datar.dataSource;
    const dataExtract = [header];
    for (let i = 0; i < incoming.length; i += 1) {
      dataExtract.push([
        incoming[i].kitegateway_reference,
        incoming[i].event_type,
        incoming[i].event_name,
        incoming[i].server_name,
        JSON.stringify(incoming[i].input_details),
        JSON.stringify(incoming[i].output_details),
        incoming[i].remark,
      ]);
    }
    const workb = XLSX.utils.book_new();
    workb.SheetNames.push("Sheet1");
    const wsData = dataExtract;
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    workb.Sheets.Sheet1 = ws;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Responses");
    XLSX.writeFile(wb, `${file} - ${time}.xlsx`);
  }

  const handleModalCancelEventModal = () => {
    setVisibilityEventModal(false);
    setSelectedEventId("");
  };

  return (
    <div>
      <h2 className="title gx-mb-4">
        <IntlMessages id="event_logs.title" />
      </h2>
      <div className="gx-d-flex justify-content-center">
        <Input.Search
          placeholder="Search Events"
          enterButton
          allowClear
          onSearch={(value) =>
            handleSearch(value, dispatch, getEvents, columns, setSearchParams)
          }
        />
      </div>
      <div className="justify-content-center">
        <DownloadBtns
          handlePdf={() => handlePdf({ columns }, { dataSource }, "Events")}
          handleXcl={() => handleXcl({ columns }, { dataSource }, "Events")}
        />
        <Table className="gx-table-responsive striped-table" {...props} />
        <Row className="pagination">
          <Col md={12}>
            <PageLimitSwitch
              resourceType="event_logs"
              limit={pageSize}
              limits={[10, 100, 200, 500, 1000, 2000, 5000, 10000]}
              totalRecords={totalRecords}
              currentPage={currentPage}
            />
          </Col>
        </Row>
      </div>
      <Modal
        visible={visibleEventModal}
        okText="Close"
        confirmLoading={loading && loading}
        onCancel={handleModalCancelEventModal}
        onOk={handleModalCancelEventModal}
        footer={`Event #${selectedEventId}`}
      >
        <EventDetailsForModal {...{ eventId: selectedEventId }} />
      </Modal>
    </div>
  );
};

export default EventLog;
